import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

const Item = props => {
  const { theme, item: { label, to, icon: Icon } = {}, onClick } = props

  return (
    <>
      <li className={'hiddenItem' in props ? 'hiddenItem' : 'item'} key={label}>
        <Link
          to={to}
          className={'hiddenItem' in props ? 'inHiddenItem' : ''}
          onClick={onClick}
          data-slug={to}
        >
          {Icon && <Icon />} {label}
        </Link>
      </li>

      {/* --- STYLES --- */}
      <style jsx>{`
        .item,
        .showItem {
          background: transparent;
          transition: all ${theme.time.duration.default};
          display: flex;
          align-items: center;

          :global(a) {
            padding: ${theme.space.inset.s};
            display: flex;
            align-items: center;
          }

          :global(svg) {
            margin: 0 ${theme.space.inset.xs} 0 0;
            opacity: 0.3;
          }
        }

        :global(.itemList .hideItem) {
          display: none;
        }

        @from-width desktop {
          .item {
            :global(a) {
              color: var(--text-color-primary);
              padding: ${theme.space.inset.s};
              transition: all ${theme.time.duration.default};
              border-radius: ${theme.size.radius.small};
              font-size: ${theme.font.size.m};
            }

            :global(.homepage):not(.fixed) & :global(a) {
              color: var(--hero-header-text);
              font-weight: ${theme.font.weight.bold};
            }

            :global(.homepage):not(.fixed) & :global(svg) {
              fill: var(--hero-header-text);
              opacity: 0.85;
            }

            :global(.homepage):not(.fixed) & :global(a:hover),
            :global(.homepage):not(.fixed) & :global(a:focus) {
              color: var(--color-brand-primary);
              background: rgba(255, 255, 255, 0.6);
            }

            :global(.homepage):not(.fixed) &:hover :global(svg),
            :global(.homepage):not(.fixed) &:focus-within :global(svg) {
              fill: var(--color-brand-primary);
              opacity: 1;
            }

            :global(a:hover) {
              color: var(--color-brand-primary);
              background: color(white alpha(-60%));
            }

            :global(svg) {
              transition: all ${theme.time.duration.default};
            }

            &:hover :global(svg) {
              fill: var(--color-brand-primary);
              opacity: 1;

              :global(.hero) & :global(svg) {
                fill: green;
              }
            }
          }

          .showItem {
            display: none;
          }

          .hiddenItem {
            text-align: left;
            padding: ${theme.space.xs};

            & :global(a.inHiddenItem) {
              color: var(--text-color-primary);
              &:hover {
                color: var(--color-brand-primary);
              }
            }
          }
        }
      `}</style>
    </>
  )
}

Item.propTypes = {
  item: PropTypes.object,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.func,
  theme: PropTypes.object.isRequired,
}

export default Item
